import React from 'react';
import { CheckCircleOutline } from 'mdi-material-ui';
import { useDispatch, useSelector } from 'react-redux';

import { MessageTypeEnum, SectionMessagesEnum } from 'app/shared/enums';
import { Alert } from 'app/components/Alert';
import { ShortPathDataActions } from 'app/store/data/shortPathData';
import { selectCarRegistrationNumber } from 'app/store/data/quotation';

import { useStyles } from './CalculationDataFoundMessageBox.styles';

function CalculationDataFoundMessageBox() {
  const classes = useStyles();
  const registrationNumber = useSelector(selectCarRegistrationNumber);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(ShortPathDataActions.setIsCepikDataRejectionModalOpened(true));
  };

  return (
    <div className={classes.root}>
      <Alert
        icon={<CheckCircleOutline />}
        text={
          <div>
            <strong>
              {SectionMessagesEnum.WeFoundYourVehicle1} {registrationNumber}!
            </strong>
            <br />
            {SectionMessagesEnum.WeFoundYourVehicle2}
            <button
              aria-label="Wprowadź dane ręcznie"
              className={classes.button}
              onClick={handleClick}
              type="button"
            >
              {SectionMessagesEnum.WeFoundYourVehicle3}
            </button>
            .
          </div>
        }
        type={MessageTypeEnum.Success}
      />
    </div>
  );
}

export default CalculationDataFoundMessageBox;
